import dynamic from 'next/dynamic';

const HeaderBarResponsive = dynamic(import('./HeaderBarResponsive'), { ssr: false });

export default HeaderBarResponsive;